import {useZero} from '@/shared/integrations/zero/use-zero'
import {AddPatientTherapySequenceObservation} from '@cypro/engine/mutators'
import {useCallback} from 'react'

export function useAddPatientTherapySequenceObservation() {
  const zero = useZero()

  return useCallback(
    (payload: AddPatientTherapySequenceObservation) =>
      zero.attemptMutation(
        zero.mutators.patientsTherapies.addObservation(payload),
        async mutation => await mutation.server
      ),
    [zero]
  )
}
